import { useEffect, useRef } from "react";

import { useRenewalHandler } from "./hooks/useRenewalHandler";
import { Loader } from "./Loader";
import { useUpgradePlanContext } from "./UpgradePlanContext";

interface RenewalProps {
  source?: string;
}

export const Renewal = ({ source }: RenewalProps) => {
  const { plan } = useUpgradePlanContext();
  const { attemptRenewal, loadingMessage } = useRenewalHandler(source);
  const hasAttemptedRenewal = useRef(false);

  useEffect(() => {
    if (plan?.id && !hasAttemptedRenewal.current) {
      hasAttemptedRenewal.current = true;
      void attemptRenewal(plan.id);
    }
  }, [plan?.id, attemptRenewal]);

  return (
    <Loader title={loadingMessage.title} subtitle={loadingMessage.subtitle} />
  );
};
